import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { useAccountFormContext } from '../../context/useAccountFormContext';

export const CompanyOwnership = () => {
  const formBag = useFormContext();

  const {
    options: { AtLeast5PctOwnershipOptions: options },
  } = useAccountFormContext();

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.AtLeast5PctOwnership"
      render={({ field: { value, onChange, ref } }) => (
        <Select
          innerRef={ref}
          value={options.find(({ value: v }) => v === value)}
          options={options}
          onChange={opt => onChange(opt?.value)}
          label="Company Ownership"
          isPortal
          tooltip="If you are still working and contributing to this account after 72, your RMDs will not begin if you do not own 5% or more of the company you are working for."
        />
      )}
    />
  );
};
